import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	showMore: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	showMore: {
		id: 'confluence-pages-readview-full.ui.confluence-pages.show-more',
		defaultMessage: 'Show more',
		description: 'Tooltip for the Confluence pages show more button',
	},
});
export default messages;
